import {PublicKey} from "openpgp";
import * as openpgp from "openpgp";

const publicKeyCache: {
  [armored: string]: PublicKey,
} = {}

const encryptMessage = async (text: string, armoredKey: string) => {
  if (typeof publicKeyCache[armoredKey] === 'undefined') {
    // console.log('read key', armoredKey.substring(0, 100))
    publicKeyCache[armoredKey] = await openpgp.readKey({ armoredKey })
  // } else {
  //   console.log('encrypt with known key', armoredKey.substring(0, 100))
  }

  const message = await openpgp.createMessage({ text })

  return await openpgp.encrypt({
    message,
    encryptionKeys: publicKeyCache[armoredKey],
    format: 'armored'
  })
}

export default encryptMessage